import { render } from "./DefaultLayout.vue?vue&type=template&id=14b993c0&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=14b993c0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-14b993c0"

export default script